var render = function render(){var _vm=this,_c=_vm._self._c;return _c('IconBtn',{attrs:{"title":"CSV","icon":"mdi-download"},on:{"click":function($event){return _vm.download()}}})
}
var staticRenderFns = []

export { render, staticRenderFns }